import React from 'react';

export default function FaqSection({ faq }) {
  if (!faq || faq.length === 0) return null;

  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faq.map(item => ({
      "@type": "Question",
      "name": item.q,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": item.a
      }
    }))
  };

  return (
    <section id="faq" className="my-12 border-t border-[#DCE3EC] pt-8">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
      <h2 className="text-xl font-bold text-[#141B22] mb-6">
        Ofte stillede spørgsmål
      </h2>
      <div className="space-y-6">
        {faq.map((item, idx) => (
          <div key={idx} className="border-b border-[#DCE3EC] pb-6 last:border-b-0">
            <h3 className="text-[17px] font-semibold text-[#141B22] mb-2">
              {item.q}
            </h3>
            <p className="text-[#5C6670] leading-relaxed">
              {item.a}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
}
